import { lazy } from 'react';

export const RealEstateHome = lazy(
  () => import('./pages/home/realEstateHome/RealEstateHome')
);

export const ConsumerGoodsHome = lazy(
  () => import('./pages/home/consumerGoods/ConsumerGoodsHome')
);
export const HomeLivingHome = lazy(
  () => import('./pages/home/homeLivingLandingPage/HomeLivingHome')
);
export const ElectronicsHome = lazy(
  () => import('./pages/home/electronicsHome/ElectronicsHome')
);
export const SalesHome = lazy(
  () => import('./pages/home/salesAndOffers/SalesHome')
);
export const FoodAndDrinkHome = lazy(
  () => import('./pages/home/foodAndDrink/FoodAndDrinkHome')
);
export const CartItems = lazy(() => import('./pages/cartItems/CartItems'));
export const CheckoutItems = lazy(
  () => import('./pages/checkoutItems/CheckoutItems')
);
// StaySmallSmall
export const StaySmallSmallSummary = lazy(
  () =>
    import(
      './pages/userDashboard/staySmallSmallDashboard/staySmallSmallSummary/StaySmallSmallSummary'
    )
);
export const StaySmallSmallStay = lazy(
  () =>
    import(
      './pages/userDashboard/staySmallSmallDashboard/staySmallSmallStay/stay-small-small-stay/StaySmallSmallStay'
    )
);
export const StaySmallSmallFavorites = lazy(
  () =>
    import(
      './pages/userDashboard/staySmallSmallDashboard/staySmallSmallFavorites/StaySmallSmallFavorites'
    )
);
export const StaySmallSmallRecentlyViewed = lazy(
  () =>
    import(
      './pages/userDashboard/staySmallSmallDashboard/staySmallSmallRecentlyViewed/StaySmallSmallRecentlyViewed'
    )
);
export const StaySmallSmallProfile = lazy(
  () =>
    import(
      './pages/userDashboard/staySmallSmallDashboard/StaySmallSmallProfile'
    )
);

export const StaySmallSmallBookingReceiptSuccess = lazy(
  () =>
    import(
      './pages/home/realEstateHome/realEstateContentSection/staySmallSmall/staySmallSmallBookingReceipt/StaySmallSmallBookingReceiptSuccess'
    )
);

export const StaySmallSmallBookingInitiatedSuccess = lazy(
  () =>
    import(
      './pages/home/realEstateHome/realEstateContentSection/staySmallSmall/staySmallSmallBookingInitiated/StaySmallSmallBookingInitiatedSuccess'
    )
);

export const StaySmallSmallSinglePropertyPage = lazy(
  () =>
    import(
      './pages/home/realEstateHome/realEstateContentSection/staySmallSmall/staySmallSmallSinglePropertyPage/StaySmallSmallSinglePropertyPage'
    )
);

export const RentSmallSmallSinglePropertyPage = lazy(
  () =>
    import(
      './pages/home/realEstateHome/realEstateContentSection/realEstateSubcategories/rentSmallSmallSingleProperty/RentSmallSmallSinglePropertyPage'
    )
);

export const RentSmallSmallAllProperties = lazy(() =>
  import(
    './pages/home/realEstateHome/realEstateContentSection/realEstateSubcategories/RentSmallSmallAllProperties'
  ).then((module) => ({ default: module.RentSmallSmallAllProperties }))
);

export const RentSmallSmallLanding = lazy(() =>
  import(
    './pages/home/realEstateHome/realEstateContentSection/realEstateSubcategories/rentSmallSmallLanding/RentSmallSmallLanding'
  ).then((module) => ({ default: module.RentSmallSmallLanding }))
);

export const RentSmallSmallLandingPrime = lazy(() =>
  import(
    './pages/home/realEstateHome/realEstateContentSection/realEstateSubcategories/rentSmallSmallPrime/RentSmallSmallLandingPrime'
  ).then((module) => ({ default: module.RentSmallSmallLandingPrime }))
);

export const ExtendStaySuccessReceipt = lazy(
  () =>
    import(
      './pages/userDashboard/staySmallSmallDashboard/staySmallSmallStay/currentStay/features/extendStay/ExtendStaySuccessReceipt'
    )
);

export const ModifyStaySuccessReceipt = lazy(
  () =>
    import(
      './pages/userDashboard/staySmallSmallDashboard/staySmallSmallStay/currentStay/features/modifyStay/ModifyStaySuccessReceipt'
    )
);

export const ModifyStayRefundSuccessReceipt = lazy(
  () =>
    import(
      './pages/userDashboard/staySmallSmallDashboard/staySmallSmallStay/currentStay/features/modifyStay/ModifyStayRefundSuccessReceipt'
    )
);

export const CancelStaySuccessReceipt = lazy(
  () =>
    import(
      './pages/userDashboard/staySmallSmallDashboard/staySmallSmallStay/currentStay/features/cancelStay/CancelStaySuccessReceipt'
    )
);

export const CheckoutPaymentSuccess = lazy(
  () => import('./pages/checkoutPaymentSuccess/CheckoutPaymentSuccess')
);

export const CheckoutPaymentFailed = lazy(
  () => import('./pages/checkoutPaymentFailed/CheckoutPaymentFailed')
);

export const SingleProductPage = lazy(
  () => import('./pages/productCategories/SingleProductPage')
);

export const UserDashboard = lazy(
  () => import('./pages/userDashboard/UserDashboard')
);
export const ShoppingOverview = lazy(
  () =>
    import('./pages/userDashboard/shopping/shoppingOverview/ShoppingOverview')
);

export const DirectDebit = lazy(
  () =>
    import(
      './pages/userDashboard/shopping/shoppingOverviewContents/DirectDebit/DirectDebit'
    )
);
export const Favorites = lazy(
  () =>
    import('./pages/userDashboard/shopping/shoppingOverviewContents/Favorites')
);
export const RecentlyViewed = lazy(
  () =>
    import(
      './pages/userDashboard/shopping/shoppingOverviewContents/recentlyViewed/RecentlyViewed'
    )
);
// export const Notifications = lazy(
//   () => import('./pages/userDashboard/notifications/Notifications')
// );

/*****RENT SMALLSMALL DASHBOARDD*****/

export const RentSmallSmallProfile = lazy(
  () =>
    import(
      './pages/userDashboard/rentSmallSmallDashboard/RentSmallSmallProfile'
    )
);

export const RentSmallSmallSummary = lazy(
  () =>
    import(
      './pages/userDashboard/rentSmallSmallDashboard/rentSmallSmallSummary/RentSmallSmallSummary'
    )
);
export const RentSmallSmallInspections = lazy(
  () =>
    import(
      './pages/userDashboard/rentSmallSmallDashboard/rentSmallSmallInspection/RentSmallSmallInspections'
    )
);

export const RentSmallSmallRental = lazy(
  () =>
    import(
      './pages/userDashboard/rentSmallSmallDashboard/rentSmallSmallRental/RentSmallSmallRental'
    )
);
export const RentSmallSmallRentalVerification = lazy(
  () =>
    import(
      './pages/userDashboard/rentSmallSmallDashboard/rentSmallSmallRentalVerification/RentSmallSmallRentalVerification'
    )
);

export const RentSmallSmallRecentlyViewed = lazy(
  () =>
    import(
      './pages/userDashboard/rentSmallSmallDashboard/rentSmallSmallRecentlyViewed/RentSmallSmallRecentlyViewed'
    )
);

export const RentSmallSmallFavorites = lazy(
  () =>
    import(
      './pages/userDashboard/rentSmallSmallDashboard/rentSmallSmallFavorites/RentSmallSmallFavorites'
    )
);

export const SubscriptionTerms = lazy(
  () => import('./pages/subscriptionTerms/SubscriptionTerms')
);

// Previously eager routes — split so they stay out of the entry chunk
export const SignUp = lazy(() => import('./pages/signUp/SignUp'));
export const Login = lazy(() => import('./pages/login/Login'));
export const ForgotPassword = lazy(
  () => import('./pages/forgotPassword/ForgotPassword')
);
export const ResetPassword = lazy(
  () => import('./pages/resetPassword/ResetPassword')
);
export const VerifyEmail = lazy(() =>
  import('./pages/verifyEmail/VerifyEmail').then((module) => ({
    default: module.VerifyEmail,
  }))
);
export const VerificationSent = lazy(
  () => import('./pages/cartItems/cartItemsContent/VerificationSent')
);
export const RentSmallSmallResults = lazy(() =>
  import(
    './pages/home/realEstateHome/realEstateContentSection/realEstateSubcategories/RentSmallSmallResults'
  ).then((module) => ({ default: module.RentSmallSmallResults }))
);
export const StaySmallSmall = lazy(() =>
  import(
    './pages/home/realEstateHome/realEstateContentSection/staySmallSmall/staySmallSmallHome/StaySmallSmall'
  ).then((module) => ({ default: module.StaySmallSmall }))
);
export const RealEstateSubCategory = lazy(() =>
  import('./pages/home/realEstateHome/RealEstateSubCategory').then(
    (module) => ({ default: module.RealEstateSubCategory })
  )
);
export const Summary = lazy(
  () =>
    import('./pages/userDashboard/shopping/shoppingOverviewContents/Summary')
);
export const Purchases = lazy(
  () =>
    import(
      './pages/userDashboard/shopping/shoppingOverviewContents/purchase/Purchases'
    )
);
export const UserAccountProfile = lazy(
  () => import('./pages/userDashboard/accountProfile/UserAccountProfile')
);
export const ProfileSummary = lazy(
  () =>
    import(
      './pages/userDashboard/accountProfile/contents/profileSummary/ProfileSummary'
    )
);
export const AccountVerification = lazy(
  () =>
    import(
      './pages/userDashboard/accountProfile/contents/accountVerification/AccountVerification'
    )
);
export const DeliveryAddress = lazy(
  () =>
    import(
      './pages/userDashboard/accountProfile/contents/deliveryAddress/DeliveryAddress'
    )
);
export const Feedback = lazy(
  () =>
    import('./pages/userDashboard/accountProfile/contents/feedback/Feedback')
);
export const ResolutionCentre = lazy(
  () =>
    import(
      './pages/userDashboard/accountProfile/contents/resolutionCentre/ResolutionCentre'
    )
);
export const TermsOfUse = lazy(() => import('./pages/termsOfUse/TermsOfUse'));
export const HowItWorks = lazy(() => import('./pages/howItWorks/HowItWorks'));
export const BuyerAndVendorProtection = lazy(
  () => import('./pages/buyerAndVendor/BuyerAndVendorProtection')
);
export const MarketplaceGuidelines = lazy(
  () => import('./pages/marketplaceGuidelines/MarketplaceGuidelines')
);
export const RefundsAndReturns = lazy(
  () => import('./pages/refundsAndReturns/RefundsAndReturns')
);
export const BuyingGuide = lazy(
  () => import('./pages/buyingGuide/BuyingGuide')
);
export const AboutUs = lazy(() => import('./pages/aboutUs/AboutUs'));
export const PrivacyPolicy = lazy(
  () => import('./pages/privacyPolicy/PrivacyPolicy')
);
export const DirectDebitSetup = lazy(
  () =>
    import(
      './pages/checkoutItems/directDebitSetup/directDebitBankSetUp/directDebitSetup/DirectDebitSetup'
    )
);
export const DirectDebitInitialized = lazy(
  () =>
    import(
      './pages/checkoutItems/directDebitSetup/directDebitBankSetUp/directDebitSetupForm/directDebitInitialized/DirectDebitInitialized'
    )
);
export const SearchProductResult = lazy(
  () => import('./pages/searchProductResult/SearchProductResult')
);
export const VendorAllProduct = lazy(
  () => import('./pages/vendorAllProduct/VendorAllProduct')
);
export const CompleteBooking = lazy(
  () =>
    import(
      './pages/home/realEstateHome/realEstateContentSection/staySmallSmall/completeBooking/CompleteBooking'
    )
);
export const BookingTerms = lazy(
  () =>
    import(
      './pages/home/realEstateHome/realEstateContentSection/staySmallSmall/bookingTermsAndConditions/BookingTerms'
    )
);
export const ExtendStayPayment = lazy(() =>
  import(
    './pages/userDashboard/staySmallSmallDashboard/staySmallSmallStay/currentStay/features/extendStay/ExtendStayPayment'
  ).then((module) => ({ default: module.ExtendStayPayment }))
);
export const SubscriberVerificationPage = lazy(
  () =>
    import(
      './pages/home/realEstateHome/realEstateContentSection/realEstateSubcategories/rentSmallSmallSingleProperty/subscriberVerification/SubscriberVerificationPage'
    )
);
export const RSSSubscriberVerificationSuccessPage = lazy(
  () =>
    import(
      './pages/home/realEstateHome/realEstateContentSection/realEstateSubcategories/rentSmallSmallSingleProperty/subscriberVerification/RSSSubscriberVerificationSuccessPage'
    )
);
export const ReturningCustomerVerificationPage = lazy(
  () =>
    import(
      './pages/home/realEstateHome/realEstateContentSection/realEstateSubcategories/rentSmallSmallSingleProperty/returningCustomerVerification/ReturningCustomerVerificationPage'
    )
);
export const RSSPaymentSetupPage = lazy(
  () =>
    import(
      './pages/home/realEstateHome/realEstateContentSection/realEstateSubcategories/rentSmallSmallSingleProperty/subscription/RSSPaymentSetupPage'
    )
);
export const RSSPaymentSuccessPage = lazy(
  () =>
    import(
      './pages/home/realEstateHome/realEstateContentSection/realEstateSubcategories/rentSmallSmallSingleProperty/subscription/RSSPaymentSuccessPage'
    )
);
export const PrimeVerificationPage = lazy(
  () =>
    import(
      './pages/home/realEstateHome/realEstateContentSection/realEstateSubcategories/rentSmallSmallPrime/primeVerification/PrimeVerificationPage'
    )
);
export const PrimeVerificationSuccessPage = lazy(
  () =>
    import(
      './pages/home/realEstateHome/realEstateContentSection/realEstateSubcategories/rentSmallSmallPrime/primeVerification/PrimeVerificationSuccessPage'
    )
);
export const PrimeReturningCustomerVerificationPage = lazy(
  () =>
    import(
      './pages/home/realEstateHome/realEstateContentSection/realEstateSubcategories/rentSmallSmallPrime/primeVerification/PrimeReturningCustomerVerificationPage'
    )
);
